import styled from 'styled-components'

import colors from './colors'

const Tags = styled.div`
  margin: 0 0 1rem 0;
`
const Tag = styled.div`
  display: inline-block;
  margin: 0 .5rem .5rem 0;

  input {
    display: none;
  }

  label {
    background: hsl(220, 80%, 96%);
    display: block;
    color: ${colors.blue};
    padding: .5rem .75rem;
    cursor: pointer;
    opacity: .8;
    font-weight: 500;
    border-radius: 4px;
    user-select: none;
  }

  label:hover {
    opacity: 1;
  }

  input:checked+label {
    background: ${colors.blue};
    color: white;
  }
`

export {
  Tags,
  Tag,
}



// WEBPACK FOOTER //
// ./src/styles/tags.js